import { EmailConfirmationStatus, IBoundEmail } from 'multirpc-sdk';

export const makeEmailStatuses = (boundEmails: IBoundEmail[]) => {
  const map: Record<EmailConfirmationStatus, Partial<IBoundEmail[]>> = {
    [EmailConfirmationStatus.PENDING]: [],
    [EmailConfirmationStatus.CONFIRMED]: [],
    [EmailConfirmationStatus.DELETED]: [],
  };

  (boundEmails || []).forEach(boundEmail => {
    map[boundEmail.status].push(boundEmail);
  });

  const pendingEmail = map[EmailConfirmationStatus.PENDING][0]?.email;
  const pendingAddress = map[EmailConfirmationStatus.PENDING][0]?.address;
  const isEmailPending = !!boundEmails.length && !!pendingEmail;

  const confirmedEmail = isEmailPending
    ? undefined
    : map[EmailConfirmationStatus.CONFIRMED][0]?.email;
  const confirmedAddress = isEmailPending
    ? undefined
    : map[EmailConfirmationStatus.CONFIRMED][0]?.address;
  const isEmailConfirmed = !!boundEmails.length && !!confirmedEmail;

  const lastLinkExpiredEmail = map[EmailConfirmationStatus.DELETED][0]?.email;
  const lastLinkExpiredAddress =
    map[EmailConfirmationStatus.DELETED][0]?.address;
  const isEmailLinkExpired =
    !isEmailPending && !isEmailConfirmed && !!lastLinkExpiredEmail;

  const isEmailNotUsed =
    !isEmailPending && !isEmailConfirmed && !isEmailLinkExpired;

  const lastEmailUsed = pendingEmail || confirmedEmail || lastLinkExpiredEmail;
  const lastAddressUsed =
    pendingAddress || confirmedAddress || lastLinkExpiredAddress;

  return {
    confirmedAddress,
    confirmedEmail,
    isEmailConfirmed,
    isEmailLinkExpired,
    isEmailNotUsed,
    isEmailPending,
    lastAddressUsed,
    lastEmailUsed,
    lastLinkExpiredEmail,
    pendingAddress,
    pendingEmail,
  };
};
